// extracted by mini-css-extract-plugin
export default {"root":"NotificationCentre_root__7ij0v"};